export default "__VITE_ASSET__BcE0zvuo__"